'use client';

import Script from 'next/script';

interface GoogleTagManagerProps {
  gtmId?: string;
  headScript?: string;
  bodyScript?: string;
}

export function GoogleTagManager({ gtmId, headScript, bodyScript }: GoogleTagManagerProps) {
  const resolvedHeadScript =
    headScript ||
    (gtmId
      ? `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`
      : null);

  const resolvedNoscriptSrc = gtmId
    ? `https://www.googletagmanager.com/ns.html?id=${gtmId}`
    : null;

  return (
    <>
      {resolvedHeadScript && (
        <Script
          id="gtm-head"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{ __html: resolvedHeadScript }}
        />
      )}
      {bodyScript ? (
        <div dangerouslySetInnerHTML={{ __html: bodyScript }} />
      ) : resolvedNoscriptSrc ? (
        <noscript>
          <iframe
            src={resolvedNoscriptSrc}
            height="0"
            width="0"
            style={{ display: 'none', visibility: 'hidden' }}
          />
        </noscript>
      ) : null}
    </>
  );
}
